import React, {Component} from'react';
import './parallaxOtherPages.css'; 
 export default class parallaxOtherPages extends Component{
     render(props){
         return(
            <div className="parallaxOtherPages_paralax-main">
                <div 
                    style={{backgroundImage: `url(${this.props.parallaxOtherPages_bg})` }}
                    className="parallaxOtherPages_parallax animated wow fadeInLeft"
                />
                     
                <div className="parallaxOtherPages_hs-home-info">
                    <div className="container parallaxOtherPages_prlx">
                        <h1 className="text-left txt-mensage wow">{this.props.parallaxOtherPages_title}</h1>
                        <h3 className="text-left txt-mensage wow">{this.props.parallaxOtherPages_desc}</h3>
                        <p className="text-left wow parallaxOtherPages_hs-txtDesc">{this.props.parallaxOtherPages_txt}</p>
                    </div>
                </div>
            </div>
         );
     }
 }